<template>
    <v-container grid-list-lg>
        <v-layout row wrap>
            <v-flex xs12 flex class="text-xs-center">
                <img :src="logoSrc">
            </v-flex>
            <v-flex xs12 flex>
                <loading v-show="uiLoading"></loading>
                <loading v-if="$firebaseClient.loadingUser" :invert="true" :loadingMessage="userLoadingMessage"
                         :fullScreen="true"></loading>
                <div id="firebaseui-auth-container" v-else v-show="!uiLoading"></div>
            </v-flex>
            <v-flex xs12 flex>
                <div class="text-xs-center">
                    <contact-support></contact-support>
                </div>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
  import firebase from 'firebase/app'
  import 'firebase/auth'
  import firebaseui from 'firebaseui'
  import Loading from '@/components/core/Loading'

  export default {
    name: 'firebase-auth',
    props: {
      redirectedFrom: {
        type: Object
      }
    },
    components: {
      Loading
    },
    data () {
      return {
        uiLoading: true,
        logoSrc: require('@/assets/logo.png')
      }
    },
    created () {
      this.$firebaseClient.startLogin(this.redirectedFrom)
      // TODO: save the redirectedFrom route to the firebase client and pass when calling onLogin?
    },
    mounted () {
      const self = this
      const uiConfig = {
        callbacks: {
          signInSuccessWithAuthResult: (authResult, redirectUrl) => false,
          uiShown: () => {
            console.log('[FIREBASE_AUTH]: Firebase UI widget ready')
            self.uiLoading = false
          }
        },
        signInSuccessUrl: '/',
        signInOptions: [
          {
            provider: firebase.auth.EmailAuthProvider.PROVIDER_ID,
            requireDisplayName: false
          }
        ],
        credentialhelper: firebaseui.auth.CredentialHelper.NONE
      }
      this.$firebaseUIClient.start('#firebaseui-auth-container', uiConfig)
    },
    computed: {
      userLoadingMessage () {
        if (!this.$firebaseClient.loadingUser && this.$firebaseClient.user) {
          return 'User profile loaded!'
        } else if (!this.$firebaseClient.loadingUser && !this.$firebaseClient.user) {
          return 'You don\'t have a user profile yet. Let\'s fix that!'
        } else {
          return 'Loading your user profile'
        }
      }
    },
    methods: {},
    watch: {
    }
  }
</script>

<style lang="scss">
    @import "../../../node_modules/firebaseui/dist/firebaseui.css";
    /*.main-logo{width:13.9em;height:11.2em;background-image:url(/static/images/logo.png);margin:0 auto}*/
</style>
